import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/common/ui-kit";
import { Label } from "@/components/ui/label";

const opts = (m) => Object.entries(m).map(([key, v]) => ({ key, label: Array.isArray(v) ? v[0] : v }));

export const ASSET_STATUS = { attivo: ["Attivo", "green"], in_magazzino: ["In magazzino", "blue"], in_riparazione: ["In riparazione", "amber"], dismesso: ["Dismesso", "neutral"], sostituito: ["Sostituito", "neutral"] };
export const LIC_STATUS = { attiva: ["Attiva", "green"], in_rinnovo: ["In rinnovo", "amber"], scaduta: ["Scaduta", "red"], cessata: ["Cessata", "neutral"] };
export const DOC_STATUS = { emesso: ["Emesso", "blue"], accettato: ["Accettato", "green"], rifiutato: ["Rifiutato", "red"], sostituito: ["Sostituito", "neutral"], annullato: ["Annullato", "neutral"] };
export const OWNERS = { cliente: "Cliente", on: "ON! (nostro)", terzi: "Terzi" };
export const AVAILABILITY = { proprieta: "Proprietà", noleggio: "Noleggio", comodato: "Comodato d'uso", leasing: "Leasing", altro: "Altro" };
export const DOC_KINDS = { offerta: "Offerta", preventivo: "Preventivo", quotazione: "Quotazione", ordine: "Ordine", conferma_ordine: "Conferma d'ordine", accettazione: "Accettazione", rinnovo: "Rinnovo", variazione: "Variazione", integrazione: "Integrazione", altro: "Altro" };
export const ACCEPT_MODES = { firma: "Firma", email: "Email", pec: "PEC", ordine: "Ordine del cliente", verbale: "Verbale", portale: "Portale", altro: "Altro" };
export const LIC_UNITS = { utente: "Utente", dispositivo: "Dispositivo", postazione: "Postazione", server: "Server", istanza: "Istanza", sito: "Sito", altro: "Altro" };
export const RENEWAL = { manuale: "Manuale", automatico: "Automatico", nessuno: "Nessuno" };
export const ASSIGN_KINDS = { asset: "Asset", contact: "Contatto cliente", user: "Utente ON!", site: "Sede", altro: "Altro" };
export const LINK_ROLES = { origine: "Origine", fornitura: "Fornitura", rinnovo: "Rinnovo", variazione: "Variazione", riferimento: "Riferimento" };
export const options = opts;

const Badge = ({ map, value, testId }) => { const [l, t] = map[value] || [value || "—", "neutral"]; return <StatusBadge tone={t} data-testid={testId}>{l}</StatusBadge>; };
export const AssetStatus = ({ value, testId }) => <Badge map={ASSET_STATUS} value={value} testId={testId} />;
export const LicStatus = ({ value, testId }) => <Badge map={LIC_STATUS} value={value} testId={testId} />;
export const DocStatus = ({ value, testId }) => <Badge map={DOC_STATUS} value={value} testId={testId} />;

export const Field = ({ l, children, className }) => <div className={`space-y-1.5 ${className || ""}`}><Label className="text-xs">{l}</Label>{children}</div>;
export const Empty = ({ children, testId }) => <p className="py-6 text-center text-sm text-slate-500" data-testid={testId}>{children}</p>;

export const useCategories = () => {
  const [d, setD] = useState([]);
  useEffect(() => { api.get("/asset-categories").then((r) => setD(r.data.items)).catch(() => setD([])); }, []);
  return d;
};

export const useCompanyCtx = (companyId) => {
  const [d, setD] = useState({ sites: [], contacts: [] });
  useEffect(() => {
    if (!companyId) { setD({ sites: [], contacts: [] }); return; }
    api.get(`/crm/companies/${companyId}`).then((r) => setD({ sites: (r.data.company.sites || []).filter((s) => s.active !== false), contacts: r.data.contacts || [] })).catch(() => setD({ sites: [], contacts: [] }));
  }, [companyId]);
  return d;
};

export const contactName = (c) => (c ? `${c.first_name || ""} ${c.last_name || ""}`.trim() || c.email : "—");
export const today = () => new Date().toISOString().slice(0, 10);
export const clean = (o) => Object.fromEntries(Object.entries(o).map(([k, v]) => [k, v === "" ? null : v]));
